import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimaryButtonComponent } from '@tran-monorepo/frontend/components';
import {
    LinkSectionComponent,
    PageHeroComponent,
    QuoteSectionComponent,
    SecondaryNavigationComponent,
    StepSectionComponent
} from '../../shared/components';
import { ClusteredTilesSectionComponent } from './components/clustered-tiles-section/clustered-tiles-section.component';
import { DatesAndDeadlinesTableComponent } from './components/dates-and-deadlines-table/dates-and-deadlines-table.component';
import { TileSectionComponent } from './components/tile-section/tile-section.component';
import { HOME_SECONDARY_NAVIGATION } from './configs/home-secondary-navigation.config';
import { HOME_FURTHER_LINKS, HOME_TRANSFORMATION_FUND_STEPS } from './configs/home-section.config';

@Component({
    selector: 'tran-home',
    imports: [
        SecondaryNavigationComponent,
        PageHeroComponent,
        TileSectionComponent,
        ClusteredTilesSectionComponent,
        DatesAndDeadlinesTableComponent,
        TranslatePipe,
        PrimaryButtonComponent,
        QuoteSectionComponent,
        LinkSectionComponent,
        StepSectionComponent,
        PrimaryButtonComponent
    ],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {
    protected readonly secondaryNavItems = HOME_SECONDARY_NAVIGATION;
    protected readonly steps = HOME_TRANSFORMATION_FUND_STEPS;
    protected readonly furtherLinks = HOME_FURTHER_LINKS;
}
